
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"48","height":"48","viewBox":"0 0 48 48","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8 21.714a4.576 4.576 0 004.571-4.571A4.576 4.576 0 008 12.57a4.576 4.576 0 00-4.571 4.572A4.576 4.576 0 008 21.714zm32 0a4.576 4.576 0 004.571-4.571A4.576 4.576 0 0040 12.57a4.576 4.576 0 00-4.571 4.572A4.576 4.576 0 0040 21.714zM42.286 24h-4.572a4.558 4.558 0 00-3.221 1.329c2.878 1.578 4.921 4.428 5.364 7.814h4.714a2.283 2.283 0 002.286-2.286v-2.286A4.576 4.576 0 0042.286 24zM24 24c4.421 0 8-3.579 8-8 0-4.421-3.579-8-8-8-4.421 0-8 3.579-8 8 0 4.421 3.579 8 8 8zm5.486 2.286h-.593C27.407 27 25.757 27.429 24 27.429c-1.757 0-3.4-.429-4.893-1.143h-.593a8.23 8.23 0 00-8.228 8.228v2.057A3.43 3.43 0 0013.714 40h20.572a3.43 3.43 0 003.428-3.429v-2.057a8.23 8.23 0 00-8.228-8.228zm-15.979-.957A4.558 4.558 0 0010.286 24H5.714a4.576 4.576 0 00-4.571 4.571v2.286a2.283 2.283 0 002.286 2.286h4.707a10.473 10.473 0 015.371-7.814z","fill":"#535353"}})])
          )
        }
      }
    